<template>
<div class="chapter">
<div class="inner_page">
<p class="blockia"><a id="page_5">This book is dedicated with admiration and affection to the men and women at NOLS who give so generously of themselves in teaching students to love and care for the wilds.</a></p><a id="page_5">
</a><p class="blocki"><a id="page_5">And it is dedicated with gratitude to the two people who gave me countless opportunities and kept me on the straight and narrow, Connie Harvey and the memory of Harold K. Harvey.</a><a id="page_6"></a></p><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?69002310